import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import "/node_modules/flag-icons/css/flag-icons.min.css";

const flags = [
  "jp", "fr", "in", "fi", "gb", "cy", "tr", "tw", "gu", "hk", "th", "kh", "ph", "vn",
];

export default function PrivateCard() {
  const { t } = useTranslation();

  const items = [
    { icon: "🎂", label: "1997/09/20" },
    { icon: "🎓", label: t("bio.private.college") },
    { icon: "🏠", label: t("bio.private.city") },
    { icon: "💼", label: t("bio.private.job") },
    { icon: "🎮", label: t("bio.private.hobby") },
  ];

  return (
    <Card
      sx={{
        maxWidth: 720,
        margin: "0 auto",
        display: "flex",
        flexDirection: { xs: "column", sm: "row" },
        overflow: "hidden",
        border: "1px solid #E2E8F0",
      }}
    >
      {/* Photo */}
      <Box
        sx={{
          width: { xs: "100%", sm: 220 },
          aspectRatio: { xs: "4/3", sm: "unset" },
          minHeight: { sm: 180 },
          flexShrink: 0,
          alignSelf: "stretch",
          backgroundImage: `url(${process.env.PUBLIC_URL}/cambodia.webp)`,
          backgroundSize: "cover",
          backgroundPosition: { xs: "center", sm: "right center" },
        }}
      />

      <CardContent
        sx={{
          flex: 1,
          p: { xs: 3, md: 4 },
          display: "flex",
          flexDirection: "column",
          gap: 0.5,
        }}
      >
        <Typography
          variant="h5"
          component="div"
          sx={{ fontWeight: 700, color: "#0F172A", mb: 0.25 }}
        >
          {t("bio.private.name")}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            display: "inline-block",
            backgroundColor: "#EFF6FF",
            color: "#3B82F6",
            px: 1.5,
            py: 0.5,
            borderRadius: 1,
            fontWeight: 600,
            fontSize: "0.78rem",
            letterSpacing: "0.03em",
            mb: 1.5,
          }}
        >
          {t("bio.private.position")}
        </Typography>

        <Divider sx={{ borderColor: "#F1F5F9", mb: 1.5 }} />

        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
          {items.map((item) => (
            <Box
              key={item.icon}
              sx={{ display: "flex", alignItems: "flex-start", gap: 1.5 }}
            >
              <Typography sx={{ fontSize: "0.9rem", lineHeight: "1.6" }}>
                {item.icon}
              </Typography>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ fontSize: "0.875rem", lineHeight: "1.6" }}
              >
                {item.label}
              </Typography>
            </Box>
          ))}
        </Box>

        {/* Visited countries */}
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75, mt: 2 }}>
          {flags.map((code) => (
            <span
              key={code}
              className={`fi fi-${code}`}
              style={{ borderRadius: 2, fontSize: "1.1rem" }}
            />
          ))}
        </Box>
      </CardContent>
    </Card>
  );
}
